import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { OwnerModel } from 'src/app/model/ownerModel.model';
import { ParcelModel } from 'src/app/model/parcelModel.model';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { AddressModel } from '../../shared/model/addressModel.model';
import { RefAddressModel } from '../../../model/refAddressModel.model';
import { ApoSearchResult, APOSearchOutputList, ResultsSelectionInput, SearchRecords } from '../models/APOSearchResult.model';
import { HttpErrorHandler } from '../../shared/services/error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class APOSearchService {

  headers: HttpHeaders;
  apiServer: string;

  constructor(private http: HttpClient, private apiRef: ApiProviderService, private errorHandler: HttpErrorHandler) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    this.apiServer = 'api/GlobalSearch/';
   }

  getGeneralAPOSearchResults(query: string, entityType: string, moduleName: string): Observable<ApoSearchResult> {
    return this.http.get<ApoSearchResult>(this.apiRef
      .getApiUrl(`${this.apiServer}APOSearch`,
         [
           {Key:'queryText', Value:query},
           {Key:'apoEntityType', Value:entityType},
           {Key:'sort', Value:''},
           {Key:'isAsc', Value:'true'},
           {Key:'isFilter', Value:'false'},
           {Key:'module', Value:moduleName},
          ]
      )).pipe(catchError(this.errorHandler.handleError));
  }

  getSelectedAddressAPOResults(searchData: ResultsSelectionInput, module: string): Observable<APOSearchOutputList> {
    return this.http.post<APOSearchOutputList>(this.apiRef
      .getApiUrl(`${this.apiServer}GetAPOSuggestionsList`, [{Key:'moduleName', Value:module}]), searchData)
      .pipe(catchError(this.errorHandler.handleError));
  }

  getRelatedAPOfromAddresses(searchData: RefAddressModel[], module: string): Observable<APOSearchOutputList> {
    const searchResults: APOSearchOutputList = {
      APOEntityType: '',
      AddressList: searchData,
      ParcelList: null,
      OwnerList: null
    };

    return this.http.post<APOSearchOutputList>(this.apiRef
      .getApiUrl(`${this.apiServer}GetAssociatedAPO`,[{Key:'moduleName', Value:module}]), searchResults)
      .pipe(map(result => (
            JSON.parse(result.toString()) as APOSearchOutputList )
      ))
      .pipe(catchError(this.errorHandler.handleError));

  }

  getRefAddressModelByKey(addr: AddressModel): Observable<RefAddressModel> {
    const params = [
      {Key:'refAddressId', Value:addr.refAddressId?.toString()},
      {Key:'sourceNumber', Value:addr.sourceNumber?.toString()},
     ];
     if(addr.UID){
       params.push({Key:'UID', Value:addr.UID});
     }
    return this.http.get<RefAddressModel>(this.apiRef
      .getApiUrl(`${this.apiServer}GetRefAddressByKey`,
         params
      )).pipe(catchError(this.errorHandler.handleError));
  }

  getLookupResultsFromAddressModel(addr: RefAddressModel): Observable<RefAddressModel[]>{
    return this.http.post<RefAddressModel[]>(this.apiRef
      .getApiUrl(`${this.apiServer}GetLookupResultsFromAddressModel`),  addr)
      .pipe(map(r => JSON.parse(JSON.stringify(r))),
      catchError(this.errorHandler.handleError));
  }

  getRelatedAPOfromParcels(searchData: ParcelModel[], module: string): Observable<APOSearchOutputList>{
    const searchResults: APOSearchOutputList = {
      APOEntityType: '',
      AddressList: null,
      ParcelList: searchData,
      OwnerList: null
    };

    return this.http.post<APOSearchOutputList>(this.apiRef
      .getApiUrl(`${this.apiServer}GetAssociatedAPO`,[{Key:'moduleName', Value:module}]), searchResults)
      .pipe(map(result => (
        JSON.parse(result.toString()) as APOSearchOutputList )
      ))
      .pipe(catchError(this.errorHandler.handleError));
}

getLookupResultsFromParcelModel(prcl: ParcelModel): Observable<ParcelModel[]>{
  return this.http.post<ParcelModel[]>(this.apiRef
    .getApiUrl(`${this.apiServer}GetLookupResultsFromParcelModel`),  prcl)
    .pipe(catchError(this.errorHandler.handleError));
}

  getRelatedAPOfromOwners(searchData: OwnerModel[], module: string): Observable<APOSearchOutputList>{
    const searchResults: APOSearchOutputList = {
      APOEntityType: '',
      AddressList: null,
      ParcelList: null,
      OwnerList: searchData
    };

    return this.http.post<APOSearchOutputList>(this.apiRef
      .getApiUrl(`${this.apiServer}GetAssociatedAPO`,[{Key:'moduleName', Value:module}]), searchResults)
      .pipe(map(result => (
        JSON.parse(result.toString()) as APOSearchOutputList )
      ))
      .pipe(catchError(this.errorHandler.handleError));
}

getLookupResultsFromOwnerModel(own: OwnerModel): Observable<OwnerModel[]>{
  return this.http.post<OwnerModel[]>(this.apiRef
    .getApiUrl(`${this.apiServer}GetLookupResultsFromOwnerModel`),  own)
    .pipe(catchError(this.errorHandler.handleError));
}

}
